import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetFetchCurrentPartner($id: ID!) {
    partner(id: $id) {
      id
      timezone
      name
      websiteUrl
      hasPredictions
      type
      status
      onboarding {
        completedAt
      }
      industry {
        id
      }
      settings {
        id
        translations {
          enabledLanguages
        }
        appearance {
          chatWidgetPhotoUrl
          chatWidgetDefaultLanguage
        }
        agents {
          isEnabled
        }
        community {
          id
          chatsEnabled
          mentionsEnabled
          evaluationsEnabled
        }
        tasks {
          isMonitoringEnabled
        }
      }
      automation {
        id
        settings {
          isBotEnabled
        }
      }
      organization {
        id
        name
        partners {
          id
          name
        }
      }
      subscriptions(status: ACTIVE) {
        edges {
          id
          node {
            id
            name
          }
        }
      }
    }
  }
`);
